import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApiQueryParams, ResponseObjectList } from "../../entities/global";
import { agent, encodeGetParams } from "../../api";
import { apiUrlV1 } from "../../config/config";
import { Cohort, CohortData } from "../../entities/cohort";
import { addNotification } from "../Notification/notificateStore";

export const getCohortes = createAsyncThunk(
  'cohort/get-cohort',
  async (params?: ApiQueryParams): Promise<ResponseObjectList<CohortData[]>> => {
    const query = encodeGetParams({ ...params })
    const req = await agent.get(`${apiUrlV1}/organization/user-cohort/list${query}`);
    if (req.ok) {
      const res = await req.json() as ResponseObjectList<CohortData[]>;
      return res;
    }
    return {
      data: [],
      limit: 250,
      page: 1,
      pages: 1,
      total: 0,
    };
  }
);

export const postCohort = createAsyncThunk(
  'cohort/post-cohort',
  async (params: { data: Cohort }, thunksApi): Promise<CohortData> => {
    try {
      const response = await agent.post(`${apiUrlV1}/organization/user-cohort`, {
        body: JSON.stringify(params.data),
      })

      if (response.ok) {
        const data = await response.json();
        thunksApi.dispatch(addNotification({ status: 'success', text: "Successfully saved" }));
        const params = Object.fromEntries(new URLSearchParams(window.location.search));
        thunksApi.dispatch(getCohortes(params));
        return data as CohortData;
      }
      if (!response.ok) {
        const data = await response.json() as { message: string };
        thunksApi.dispatch(addNotification({ status: 'error', text: data.message }));
      }

      throw Error("Request is not found");
    } catch (error) {
      throw Error("Request is not found");
    }
  }
)

export const patchCohort = createAsyncThunk(
  'cohort/patch-cohort',
  async (params: { data: Cohort,id:number }, thunksApi): Promise<CohortData> => {
    try {
      const response = await agent.patch(`${apiUrlV1}/organization/user-cohort/${params.id}`, {
        body: JSON.stringify(params.data),
      })

      if (response.ok) {
        const data = await response.json();
        thunksApi.dispatch(addNotification({ status: 'success', text: "Successfully saved" }));
        const params = Object.fromEntries(new URLSearchParams(window.location.search));
        thunksApi.dispatch(getCohortes(params));
        return data as CohortData;
      }
      if (!response.ok) {
        const data = await response.json() as { message: string };
        thunksApi.dispatch(addNotification({ status: 'error', text: data.message }));
      }

      throw Error("Request is not found");
    } catch (error) {
      throw Error("Request is not found");
    }
  }
)